import { VeritySettingsPage } from "./webpages/settings-root";
import i18n from "../i18n";

export const VerityCourseSettingsPortal = () => {
	return <VeritySettingsPage settingGroup="course" hiddenH1={i18n.t("portal.portalTSX.courseSetting")} />;
};

export const VerityInstituteSettingsPortal = () => {
	return <VeritySettingsPage settingGroup="institute" hiddenH1={i18n.t("portal.portalTSX.instiSetting")} />;
};

export const VerityThirdPartyIntegrationPortal = () => {
	return <VeritySettingsPage settingGroup="thirdParty" hiddenH1={i18n.t("portal.portalTSX.scopeSettings")} />;
};

export const InstituteScopeSettingsPortal = () => {
	return <VeritySettingsPage settingGroup="scope" hiddenH1={i18n.t("portal.portalTSX.scopeSettings")} />;
};

export const UserSettingsPortal = () => {
	return <VeritySettingsPage settingGroup="user" hiddenH1={i18n.t("portal.portalTSX.userSettings")} />;
};
